import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ModuleType } from '../../../../../types/modules';
import Zone, { ZoneGroup } from '../../../Layout/Zone';
import { ZoneType } from '../../../../../types/layout';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';

import CommissionSlider from './CommissionSlider';
import PrintsSlider from './PrintsSlider';
import PremiumContentSlider from './PremiumContentSlider';

import EmptyState from '../_partials/EmptyState';

import s from './ShopAll.scss';

const mapModuleTypeToWidgetComponent = {
  [ModuleType.COMMISSIONS]: CommissionSlider,
  [ModuleType.PRINTS]: PrintsSlider,
  [ModuleType.PREMIUM_CONTENT]: PremiumContentSlider,
};

export interface Props {
  className?: string;
  hasNoCommissions?: boolean;
  isCurrentUserProfileOwner?: boolean;
}

const defaultProps = {};

const enhance = compose(
  withSectionFetchSpinner,
  withTranslation()
);
export class ShopAll extends React.Component<Props & WithTranslation> {
  static defaultProps: Props = defaultProps;
  render() {
    const { hasNoCommissions, isCurrentUserProfileOwner } = this.props;
    if (hasNoCommissions && !isCurrentUserProfileOwner) {
      return <EmptyState view="large" />;
    }

    return (
      <div className={classnames(s['root'], this.props.className)}>
        <ZoneGroup>
          <Zone
            type={ZoneType.TOP_BAR}
            isRemovable={false}
            mapModuleTypeToWidgetComponent={mapModuleTypeToWidgetComponent}
          />
        </ZoneGroup>
      </div>
    );
  }
}

export default enhance(ShopAll) as React.ComponentType<Props>;
